// Navigation Bar SECTION
const navBar = {
  show: true,
};

// Main Body SECTION
const mainBody = {
  gradientColors: "#5eead4, #99f6e4, #2dd4bf, #6ee7b7",
  firstName: "Oyetunde",
  middleName: "",
  lastName: "Awotunde",
  message: " Passionate about changing the world with technology. ",
  icons: [
    {
      image: "fa-github",
      url: "https://github.com/tundeblockchain",
    },
  ],
};

const about = {
  show: true,
  heading: "About Me",
  imageLink: require("../editable-stuff/about.png"),
  imageSize: 375,
  message:
    "My name is Oyetunde Awotunde but you can call me Tunde xD. I’m a senior software developer with 5 years worth of experience. I'm most passionate about making the world a better place through the use of technology. I've found a new love with blockchain technology.",
  resume: require("../editable-stuff/resume.pdf"),
};

// PROJECTS SECTION
const projects = {
  show: true,
  heading: "Recent Projects",
  data: [
    {
      name: "Property Score",
      description: "AI property-investment scoring for UK listings (Rightmove / Zoopla / OnTheMarket).",
      github: ["https://github.com/tundeblockchain/Property-Score-Frontend"],
      liveUrl: "https://property-score.netlify.app/",
      image: require("../assets/img/projects/property-score.png"),
    },
    {
      name: "Color Charm",
      description: "AI-generated printable colouring pages.",
      github: ["https://github.com/tundeblockchain/Colouring-Frontend"],
      liveUrl: "https://colorcharm.app",
      image: require("../assets/img/projects/colorcharm.png"),
    },
    {
      name: "Wende Studio",
      description: "AI interior design / room refresh with shoppable results.",
      github: null,
      liveUrl: "https://wendestudio.com",
      image: require("../assets/img/projects/wende-studio.png"),
    },
    {
      name: "Cinema Ticketing",
      description: "React frontend + blockchain contracts for NFT cinema ticketing.",
      github: [
        "https://github.com/tundeblockchain/cinema-ticketing",
        "https://github.com/tundeblockchain/cinema-ticketing-backend"
      ],
      liveUrl: "https://mycinematicketing.netlify.app/",
      image: require("../assets/img/projects/cinema-ticketing.png"),
    },
  ],
};

// Leadership SECTION
const leadership = {
  show: false,
  heading: "Leadership",
  message:
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vitae auctor eu augue ut lectus arcu bibendum at varius. Libero justo laoreet sit amet cursus sit amet. Imperdiet dui accumsan sit amet nulla facilisi morbi. At auctor urna nunc id. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Et magnis dis parturient montes nascetur ridiculus mus mauris. In nisl nisi scelerisque eu ultrices vitae auctor. Mattis nunc sed blandit libero volutpat sed cras ornare. Pulvinar neque laoreet suspendisse interdum consectetur libero.",
  images: [
    { 
      img: require("../editable-stuff/about.png"), 
      label: "First slide label", 
      paragraph: "Nulla vitae elit libero, a pharetra augue mollis interdum." 
    }
  ],
  imageSize: {
    width:"615",
    height:"450"
  }
};

// SKILLS SECTION
const skills = {
  show: true,
  heading: "Skills",
  hardSkills: [
    { name: "C#", value: 90 },
    { name: "SQL", value: 75 },
    { name: "Data Structures", value: 85 },
    { name: "Solidity", value: 75 },
    { name: "JavaScript", value: 85 },
    { name: "React", value: 70 },
    { name: "HTML/CSS", value: 65 },
    { name: "Python", value: 60 },
  ],
  softSkills: [
    { name: "Goal-Oriented", value: 80 },
    { name: "Collaboration", value: 90 },
    { name: "Positivity", value: 75 },
    { name: "Adaptability", value: 85 },
    { name: "Problem Solving", value: 75 },
    { name: "Empathy", value: 90 },
    { name: "Organization", value: 70 },
    { name: "Creativity", value: 90 },
  ],
};

// GET IN TOUCH SECTION
const getInTouch = {
  show: true,
  heading: "Get In Touch",
  message:
    "I'm currently looking for full-time Software Engineering or blockchain developer opportunities! If you know of any positions available, if you have any questions, or if you just want to say hi, please feel free to email me at",
  email: "tunde.awotunde1@gmail.com",
};

const experiences = {
  show: false,
  heading: "Experiences",
  data: [
    {
      role: 'Senior Software Engineer',
      companylogo: require('../assets/img/dell.png'),
      date: 'September 2020 – Present',
    },
    {
      role: 'Software Developer',
      companylogo: require('../assets/img/boeing.png'),
      date: 'January 2020 – September 2020',
    },
    {
      role: 'Junior Developer',
      companylogo: require('../assets/img/boeing.png'),
      date: 'February 2019 – January 2020',
    },
    {
      role: 'Graduate Developer',
      companylogo: require('../assets/img/boeing.png'),
      date: 'September 2018 – February 2019',
    },
  ]
}

// Blog SECTION
// const blog = {
//   show: false,
// };

export { navBar, mainBody, about, projects, skills, leadership, getInTouch, experiences };
